module.exports = __webpack_public_path__ + "img/tabletennis.3aa4a767.svg";